
document.addEventListener("DOMContentLoaded", function () {

  const container = document.querySelector(".carousel");
  if (!container) return;

  // function activateItem(item) {
  //   document.querySelectorAll(".carousel-item")
  //     .forEach(i => i.classList.remove("active"));

  //   item.classList.add("active");
  // }

  // 👉 TOUCH + CLICK support
  container.addEventListener("pointerup", function (e) {

    const item = e.target.closest(".carousel-item");
    if (!item) return;

    const video = item.querySelector("video");
    const soundBtn = e.target.closest(".sound-toggle");
    const soundBtnicon = e.target.closest(".sound-toggle img");

    // ✅ SOUND toggle
    if (soundBtn && video) {
      e.stopPropagation();
      if(video.muted)
      {
        soundBtnicon.src = "https://cdn.shopify.com/s/files/1/0938/1858/5388/files/sound.svg" 
      }
      else
      {
        soundBtnicon.src = "https://cdn.shopify.com/s/files/1/0938/1858/5388/files/muted_a8a20059-00b6-4cad-a6ad-9ae74c26e910.svg"
      }
      video.muted = !video.muted;
      soundBtn.classList.toggle("muted", video.muted);
      return;
    }

    // ✅ VIDEO play/pause
    if (e.target.tagName === "VIDEO" && video) {
      e.stopPropagation();

      document.querySelectorAll(".carousel video").forEach(v => {
        if (v !== video) v.pause();
      });

      video.paused ? video.play() : video.pause();
      activateItem(item);
      return;
    }

    // ✅ NORMAL item tap → activate
    activateItem(item);

  }, { passive: false });

});

document.addEventListener("DOMContentLoaded", function () {

  const carousel = document.querySelector(".carousel");

  function centerItem(item) {
    const containerRect = carousel.getBoundingClientRect();
    const itemRect = item.getBoundingClientRect();

    const scrollOffset =
      item.offsetLeft -
      (carousel.offsetWidth / 2) +
      (item.offsetWidth / 2);

    carousel.scrollTo({
      left: scrollOffset,
      behavior: "smooth"
    });
  }

  carousel.addEventListener("click", function (e) {

    const item = e.target.closest(".carousel-item");
    if (!item) return;

    // active class switch
    document.querySelectorAll(".carousel-item")
      .forEach(i => i.classList.remove("active"));

    item.classList.add("active");

    // center scroll
    centerItem(item);

  });

});


window.addEventListener('load', () => {
    setTimeout(() => {
        document.querySelectorAll('.grid-media')
            .forEach(el => {
                el.style.aspectRatio = '1 / 1';
            });
    }, 1200);
});



document.addEventListener("pointerdown", function (e) {
  const btn = e.target.closest(".tbs_cartbutton");
  if (!btn) return;
  setTimeout(function() {
    const miniCartBtn = document.querySelector("#cart-icon-bubble");
    if (miniCartBtn) {
      //miniCartBtn.click();
      console.log("Mini cart opened");
      // refreshMiniCart();
    }
  }, 1500);
 
});


// function refreshMiniCart() {
//   fetch('/cart.js')
//     .then(response => response.json())
//     .then(cart => {
//       console.log(cart); // cart data
//         alert("refresh")
//       // Example: update cart count
//       document.querySelector('.cart-count').textContent = cart.item_count;

//       // You can rebuild your minicart HTML here dynamically
//     });
// }

// function refreshMiniCart() {
//   fetch('/cart.js')
//     .then(response => response.json())
//     .then(cart => {

//       /* ======================
//          UPDATE CART COUNT
//       ====================== */
//       const countEl = document.querySelector('.cart-count-drawer');
//       if (countEl) {
//         countEl.textContent = `(${cart.item_count})`;
//       }

//       /* ======================
//          BUILD CART HTML
//       ====================== */
//       const cartBody = document.querySelector('.cart-body');

//       if (!cartBody) return;

//       if (cart.item_count === 0) {
//         cartBody.innerHTML = `
//           <div class="cart-empty text-center p-30">
//             <h6>Your cart is currently empty!</h6>
//           </div>
//         `;
//         return;
//       }

//       let itemsHTML = '';

//       cart.items.forEach(item => {
//         itemsHTML += `
//           <div class="mini-cart-item flex gap-10 p-15 border-bottom">
//             <img src="${item.image}" width="70">
//             <div>
//               <p>${item.product_title}</p>
//               <p>Qty: ${item.quantity}</p>
//               <p>${(item.final_price / 100).toFixed(2)}</p>
//             </div>
//           </div>
//         `;
//       });

//       cartBody.innerHTML = itemsHTML;

//     });
// }



//hide main product form related products
document.addEventListener("DOMContentLoaded", function () {

  // Run only on product page
  if (!window.location.pathname.includes("/products/")) return;

  var currentPath = window.location.pathname;
  var slides = document.querySelectorAll(".swiper-slide");

  var validSlides = [];

  slides.forEach(function (slide) {

    var productLink = slide.querySelector("a[href*='/products/']");
    if (!productLink) return;

    var productPath = new URL(productLink.href).pathname;

    // Exclude current product
    if (productPath !== currentPath) {
      validSlides.push(slide);
    } else {
      slide.remove();
    }

  });

  // Keep only first 2 products
  validSlides.forEach(function (slide, index) {
    if (index >= 2) {
      slide.remove();
    }
  });

});

//Review Count
document.addEventListener("DOMContentLoaded", function () {

  setTimeout(function () {

    var reviewElements = document.querySelectorAll(".jdgm-prev-badge__text");

    reviewElements.forEach(function (el) {
      el.style.display = "block";
      var text = el.textContent.trim(); 
      var number = text.match(/\d+/); 

      if (number) {
        el.textContent = "(" + number[0] + ")";
      }

    });

  }, 2000); // 1000ms delay

});